<template>
    <ToggleGrid/>
    <UserName />
    <GetHeroNavigation :show-home-button="true"/>
    <div v-if="checkPath" class="profile-hero">
        <UserThemeCoverImage v-if="templateSettings.showProfilePicture" />
        <div class="profile-links">
            <UserSocialLinks />
        </div>
    </div>
    <div v-if="checkPath" class="profile-bio">
        <UserPortfolioDescription />
    </div>
</template>

<script>
    import UserName from "../../common/user/UserName.vue";
    import UserThemeCoverImage from "../../common/user/UserThemeCoverImage.vue";
    import UserSocialLinks from "../../common/user/UserSocialLinks.vue";
    import UserPortfolioDescription from "../../common/user/UserPortfolioDescription.vue";
    import ToggleGrid from "../../../../common/components/ToggleGrid.vue";
    import GetHeroNavigation from "../../common/hero/GetHeroNavigation.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "ProfileThemeSix",
        components: {
            GetHeroNavigation,
            ToggleGrid,
            UserPortfolioDescription,
            UserSocialLinks,
            UserThemeCoverImage,
            UserName
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            portfolio() {
                return this.viewData.portfolio
            },
            templateSettings() {
                return this.viewData.portfolio.templateSettings
            },
            checkPath() {
                return !window.location.pathname.includes('/p/') &&
                    !window.location.pathname.includes('/about') &&
                    !window.location.pathname.includes('/contact')
            },
        }
    }
</script>